import { useState } from "react";
import { PATH_EVENTO_PRODUCTION } from "../../../const/PATH";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { EventoSlug } from "../../utils/EventoSlug";
import { Link } from "react-router-dom";

const Evento = ({ descount, data }) => {
  const [image, setImage] = useState(
    `${PATH_EVENTO_PRODUCTION}${data?.imagen}`
  );

  const manejarError = () => {
    setImage("/assets/img/eventos/imageNotFound.svg");
  };

  if (descount) {
    return (
      <Link
        to={`/entrada/${EventoSlug(data?.nombre, data?.id)}`}
        title="Ir al evento"
      >
        <div
          className="w-100 box-evento-hover border border-3 overflow-hidden"
          style={{ borderRadius: "5px" }}
        >
          <div className="box-evento position-relative">
            <div className="overflow-hidden" style={{ height: "300px" }}>
              <div className="text-white cardOffer d-flex align-items-center justify-content-center">
                <span className="d-block GothamBold fs-5">{`${data?.cupones[0].descuento}%`}</span>
              </div>
              <img
                src={image}
                className="w-100 h-100"
                style={{ objectFit: "cover" }}
                onError={manejarError}
              />
            </div>

            <div
              className="w-100 text-white text-center Grifter bg-naranja"
              style={{ borderRadius: "0px 0px 0px 0px", fontSize: "10px" }}
            >
              {data?.categorias.length > 0 ? data?.categorias[0].nombre : ""}
            </div>

            <div className="text-center px-3 py-2">
              <h1
                className="Grifter fs-6  text-dark fs-6"
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  wordBreak: "break-word",
                  minHeight:
                    "2.8em",
                  lineHeight: "1.4em" ,
                }}
              >
                {data?.nombre}
              </h1>
              <div className="precio fs-5  mt-2 text-dark">
                <span
                  className="d-block text-muted"
                  style={{ fontSize: "10px" }}
                >
                  Desde
                </span>
                {data?.entradas[0].precio <= 0
                  ? data?.entradas[0]?.tipo
                  : `$${parseFloat(data?.entradas[0].precio).toLocaleString("es-AR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`}
              </div>
              <span className="d-block text-dark" style={{ fontSize: "10px", height: "20px" }}>
                {data?.fechas.length > 0
                  ? `${format(
                      new Date(data?.fechas[0].fecha),
                      "eeee, d 'de' MMMM 'de' yyyy",
                      { locale: es }
                    ).toString()} | ${data?.fechas[0].hora.slice(0, 5)} Hrs`
                  : null}
              </span>
              <span
                className="text-dark w-100 text-center d-block"
                style={{ fontSize: "10px" }}
              >
                {`${data?.nombre_sitio.substring(0, 15)} | ${
                  data?.localidad
                } - ${data?.provincia}`}
              </span>
              <button
                className="btn btn-custom-amarillo Grifter py-1 my-2"
                style={{ fontSize: "12px", borderRadius: "10px" }}
              >
                Comprar entradas
              </button>
            </div>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/entrada/${EventoSlug(data?.nombre, data?.id)}`}
      title="Ir al evento"
    >
      <div
        className="w-100 box-evento-hover border border-3 overflow-hidden"
        style={{ borderRadius: "5px" }}
      >
        <div className="box-evento position-relative">
          <div className="overflow-hidden" style={{ height: "300px" }}>
            <div className="text-white cardOffer d-none">
              <span className="d-block GothamBold fs-5">25</span>
              <span className="d-block GothamBold fs-7 text-white">Abril</span>
            </div>
            <img
              src={image}
              className="w-100 h-100"
              style={{ objectFit: "cover" }}
              onError={manejarError}
            />
          </div>

          <div
            className="w-100 text-white text-center Grifter bg-naranja"
            style={{ borderRadius: "0px 0px 0px 0px", fontSize: "10px" }}
          >
            {data?.categorias.length > 0 ? data?.categorias[0].nombre : ""}
          </div>

          <div className="text-center px-3 py-2">
            <h1
              className="Grifter fs-6  text-dark fs-6"
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                wordBreak: "break-word",
                minHeight:
                  "2.8em" /* Asegura 2 líneas (ajustar según font-size y line-height) */,
                lineHeight: "1.4em" /* Define la altura de cada línea */,
              }}
            >
              {data?.nombre}
            </h1>
            <div className="precio  fs-5  mt-2 text-dark">
              <span className="d-block text-muted" style={{ fontSize: "10px" }}>
                Desde
              </span>
              {data?.entradas[0]?.precio <= 0
                ? data?.entradas[0]?.tipo
                : `$${parseFloat(data?.entradas[0]?.precio).toLocaleString("es-AR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`}
            </div>
            <span className="d-block text-dark" style={{ fontSize: "10px", height: "20px" }}>
              {data?.fechas.length > 0
                ? `${format(
                    new Date(data?.fechas[0].fecha),
                    "eeee, d 'de' MMMM 'de' yyyy",
                    { locale: es }
                  ).toString()} | ${data?.fechas[0].hora.slice(0, 5)} Hrs`
                : null}
            </span>
            <span
              className="text-dark w-100 text-center d-block"
              style={{ fontSize: "10px" }}
            >
              {`${data?.nombre_sitio.substring(0, 20)} | ${data?.localidad} - ${
                data?.provincia
              }`}
            </span>
            <button
              className="btn btn-custom-amarillo Grifter py-1 my-2"
              style={{ fontSize: "12px", borderRadius: "10px" }}
            >
              Comprar entradas
            </button>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default Evento;
